import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminLogin from '../admin/pages/AdminLogin';
import AdminDashboard from '../admin/pages/AdminDashboard';
// import AdminUsers from '../pages/AdminUsers';
import AdminUserDetail from '../admin/pages/AdminUserDetail'; // ✅ ADD THIS LINE
import AdminUsers from '../admin/pages/AdminUsers'; // Uncomment if you have AdminUsers component
import AdminProtectedRoute from '../admin/components/AdminProtectedRoute';
import AdminInstructions from '../admin/pages/AdminInstructions';
import AdminPaymentHistory from '../admin/pages/AdminPaymentHistory';
import AdminSubscriptionManagement from '../admin/pages/AdminSubscriptionManagement';
import AdminCategories from '../admin/pages/AdminCategories';
const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Admin Routes */}
      <Route path="/login" element={<AdminLogin />} />
      
      {/* Protected Admin Routes */}
      <Route
        path="/dashboard"
        element={
          <AdminProtectedRoute>
            <AdminDashboard />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <AdminProtectedRoute>
            <AdminUsers />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/users/:userId"
        element={
          <AdminProtectedRoute>
            <AdminUserDetail />
          </AdminProtectedRoute>
        }
      />
       <Route
        path="/instructions"
        element={
          <AdminProtectedRoute>
            <AdminInstructions />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/payments"
        element={
          <AdminProtectedRoute>
            <AdminPaymentHistory />
          </AdminProtectedRoute>
        }
      />
       <Route
        path="/subscriptions"
        element={
          <AdminProtectedRoute>
            <AdminSubscriptionManagement />
          </AdminProtectedRoute>
        }
      />
      <Route
        path="/categories"
        element={
          <AdminProtectedRoute>
            <AdminCategories />
          </AdminProtectedRoute>
        }
      />
      
      
      {/* Default redirect to dashboard */}
      <Route
        path="/"
        element={
          <AdminProtectedRoute>
            <AdminDashboard />
          </AdminProtectedRoute>
        }
      />
    </Routes>
  );
};

export default AdminRoutes;